import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const GetReverseProposalGoodsDetailRequestSchema = z
  .object({
    goodsNo: z.number(),
  })
  .describe('GetReverseProposalGoodsDetailRequestSchema');

export type GetReverseProposalGoodsDetailRequest = z.infer<
  typeof GetReverseProposalGoodsDetailRequestSchema
>;

const GetReverseProposalGoodsDetailResponseDataSchema = z
  .object({
    goodsNo: z.number(),
    imageUrl: z.string(),
    brandId: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    isSoldOut: z.boolean(),
  })
  .describe('GetReverseProposalGoodsDetailResponseDataSchema');

const GetReverseProposalGoodsDetailResponseSchema = createApiResponseSchema(
  GetReverseProposalGoodsDetailResponseDataSchema,
);

export type GetReverseProposalGoodsDetailResponse = z.infer<
  typeof GetReverseProposalGoodsDetailResponseSchema
>;

export const getReverseProposalGoodsDetail = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetReverseProposalGoodsDetailRequestSchema),
    async (
      params: GetReverseProposalGoodsDetailRequest,
    ): Promise<GetReverseProposalGoodsDetailResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetReverseProposalGoodsDetailResponse>(
          urlJoin(campaignsApiPath.getReverseProposalGoodsDetail(params.goodsNo)),
        );
        return response;
      }),
    validateApiResponse(GetReverseProposalGoodsDetailResponseSchema),
  ),
);
